import React from 'react'
import PropTypes from 'prop-types'
import { FlatButton, CircularProgress, TextField, SelectField, MenuItem } from 'material-ui'
import classNames from 'classnames/bind'
import styles from './styles.css'

const cx = classNames.bind(styles)

class AIAssistantPopoverContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prompt: 'Please help me draft a response to this conversation.',
      tone: 'professional'
    };
  }

  handlePromptChange = (e) => {
    this.setState({ prompt: e.target.value });
  }

  handleToneChange = (e, index, value) => {
    this.setState({ tone: value });
  }

  handleGenerate = () => {
    this.props.onGenerate(this.state.prompt, this.state.tone);
  }

  render() {
    const { loading, error, generatedText, onAccept, onReject, onClose, messages } = this.props;
    const { prompt, tone } = this.state;

    if (error) {
      return (
        <div>
          <p className={cx('error')}>Error: {error}</p>
          <div className={cx('buttonContainer')}>
            <FlatButton 
              label="Close" 
              primary={true} 
              onClick={onClose}
            />
          </div>
        </div>
      )
    }

    return (
      <div className={cx('container')}>
        <h4>Generate message</h4>
        <div className={cx('disclaimer')}>
          <em>AI-generated content may contain inaccuracies and should be reviewed before use.</em>
        </div>
        <div className={cx('inputForm')}>
          <TextField
            floatingLabelText="What would you like to say?"
            hintText="e.g. Please help me draft a response to this conversation."
            fullWidth={true}
            multiLine={true}
            rows={2}
            value={prompt}
            onChange={this.handlePromptChange}
          />
          
          <SelectField
            floatingLabelText="Tone"
            value={tone}
            onChange={this.handleToneChange}
            className={cx('toneSelector')}
          >
            <MenuItem value="professional" primaryText="Professional" />
            <MenuItem value="casual" primaryText="Casual" />
            <MenuItem value="enthusiastic" primaryText="Enthusiastic" />
            <MenuItem value="formal" primaryText="Formal" />
          </SelectField>
        </div>
        <div className={cx('generatedResponseContainer')}>
          {loading && (
            <div className={cx('loadingContainer')}>
              <CircularProgress color="#711896" size={40} />
              <p>Generating AI response...</p>
            </div>
          )}
          
          {generatedText && (
            <div className={cx('content')}>
              {generatedText}
            </div>
          )}
          
          <div className={cx('buttonContainer')}>
            {generatedText ? (
              <div>
                <FlatButton 
                  label="Generate Again" 
                  onClick={this.handleGenerate}
                  disabled={!prompt.trim()}
                  className={cx('button')}
                />
                <FlatButton 
                  label="Keep" 
                  primary={true} 
                  onClick={onAccept}
                  className={cx('button')}
                />
              </div>
            ) : (
              <div>
                <FlatButton 
                  label="Cancel" 
                  onClick={onClose}
                  className={cx('button')}
                />
                <FlatButton 
                  label="Generate" 
                  primary={true} 
                  onClick={this.handleGenerate}
                  disabled={!prompt.trim()}
                  className={cx('button')}
                />
              </div>
            )}
            </div>
        </div>
      </div>
    )
  }
}

AIAssistantPopoverContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  generatedText: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired
}

export default AIAssistantPopoverContent



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/AIAssistant/AIAssistantPopoverContent/index.js